import React from "react";
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import InfoIcon from 'SVGS/InfoIcon';
import { Tooltip } from 'react-tooltip';

function CustomCheckbox({
  label,
  required,
  name,
  labelClass,
  checked,
  onChange,
  disabled,
  toolTip,
  tooltipWidth = 220,
  Icon,
  iconClass,
  ...inputProps
}) {
  const IconComponent = Icon || InfoIcon;

  return (
    <div className="flex items-center my-2 ml-3 ">
      <div
        onClick={
          onChange && !disabled
            ? (e) =>
                onChange({
                  ...e,
                  target: {
                    type: "checkbox",
                    checked: checked ? true : false,
                    name,
                  },
                })
            : () => {}
        }
        className={`border-secondaryLight  rounded-md  ${`${
          disabled
            ? "opacity-50 pointer-events-none"
            : "opacity-100 cursor-pointer"
        }`}  text-white border p-1  ${checked && "bg-primary border-primary"}`}
      >
        <img width={8} height={8} src="/img/whiteTick.svg" alt="cross" />
      </div>
      {label && (
        <label
          onClick={
            onChange && !disabled
              ? () =>
                  onChange({
                    target: {
                      type: "checkbox",
                      checked,
                      name,
                    },
                  })
              : () => {}
          }
          htmlFor={name}
          className={`${labelClass ? labelClass : "text-gray-700 m-0 ml-2 "} ${
            required && "required"
          }`}
        >
          {label}
          {toolTip && (
            <>
              <IconComponent 
                className={`inline ${iconClass || ""}`} 
                size={14} 
                data-tooltip-id={`${name}-tooltip`} 
                data-tooltip-content={toolTip}
                style={{ marginLeft: '4px' }}
              />
              <Tooltip id={`${name}-tooltip`} style={{ zIndex: 2, maxWidth: tooltipWidth }} />
            </>
          )}
        </label>
      )}
    </div>
  );
}

export default withFeatureSafe(CustomCheckbox);